import moment from "moment";
import React, {Component} from "react";
import {toast} from "react-toastify";
import ApiConnect from "../../../Utils/ApiConnect";
import AutoComplete from "../../Components/AutoComplete";

export default class ReceiptVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      accountHeads: false,
      selectedAccount: false,
      payment: false,
      amount: false,
      narration: false,
      formError: false,
      previewImage: [],
      docs: [],
      btnDisable: false,
    };
  }
  componentDidMount() {
    this.fetchAccountDetails();
  }
  fetchAccountDetails() {
    ApiConnect.get("/Module/Accounts/AccountHead/Details")
      .then((response) => {
        this.setState({ accountHeads: response.data });
      })
      .catch((error) => console.log(error));
  }
  imageHandleChange(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({ docs: e.target.files, previewImage: fileArray });
    }
  }
  setSelectedAccount = (e) => {
    this.setState({ selectedAccount: e.id });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("account", this.state.selectedAccount);
    Fdatas.append("narration", this.state.narration);
    Fdatas.append("amount", this.state.amount);
    Fdatas.append(
      "date",
      this.state.date ? moment(this.state.date).format("Y-MM-DD") : ""
    );
    Fdatas.append("payment", this.state.payment);
    Fdatas.append("docs", this.state.docs);
    ApiConnect({
      method: "post",
      url: "/Module/Vouchers/Main/NewReceipt",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            date: false,
            drAccount: false,
            crAccount: false,
            payment: false,
            crAmount: 0,
            drAmount: 0,
            narration: false,
            formError: false,
            previewImage: [],
            docs: [],
            btnDisable: false,
          });
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  render() {
    const AccountData = this.state.selectedAccount;
    return (
      <div className="card">
        <div className="card-title">
          <div className="d-flex">
            <h5>Receipt Voucher Entry</h5>
          </div>
        </div>
        <div className="card-body">
          <div className="row invoice-info bg-white">
            <div className="col-4 pb-3">
              <div className="row form-group">
                <div className="col">
                  <label>Date *</label>
                  <input
                    className="form-control"
                    type="date"
                    name="date"
                    onChange={(e) => this.setState({ date: e.target.value })}
                    defaultValue={this.state.date}
                  />
                </div>
              </div>
            </div>
            <div className="col-8 pb-3 row">
              <address className="col">
                Type: <strong>{AccountData.group || ""}</strong>
                <br />
                <b>Address: </b>
                {AccountData.address || ""}
                <br />
              </address>
              <address className="col">
                <b>Contact: </b> {AccountData.contact || ""}
                <br />
                <strong>Due: {AccountData.balance || ""}/</strong>
                <br />
              </address>
              <address className="col">
                <b>Last Credit: </b>
                {AccountData.lastCredit || ""}
                <br />
                <b>Last Debit: </b>
                {AccountData.lastDebit || ""}
              </address>
            </div>
          </div>

          <form onSubmit={(e) => this.handleSubmit(e)}>
            <div className="col-xs-12">
              <p className="text-danger">{this.state.formError}</p>
              <table className="table table-separated table-sm">
                <thead>
                  <tr>
                    <th>Received From</th>
                    <th>Description</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="col-4">
                      {this.state.accountHeads && (
                        <AutoComplete
                          action={this.setSelectedAccount}
                          name="account"
                          // defaultFallback={this.ChangeProductStatus}
                          placeHolder="Received from"
                          items={this.state.accountHeads}
                        />
                      )}
                    </td>
                    <td className="col-4">
                      <textarea
                        className="form-control"
                        rows={2}
                        placeholder="Narrator"
                        name="notes"
                      />
                    </td>
                    <td className="col4">
                      <input className="form-control" type="number" required />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="row">
                <div className="col-md-7">
                  <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                    <h6 className="mb-0 fw-bold ">Images</h6>
                  </div>
                  <div className="card-body border-dark b-1 btn-out-dashed">
                    <div className="file-group">
                      <input
                        type="file"
                        id="file"
                        multiple
                        accept="image/*"
                        onChange={(e) => this.imageHandleChange(e)}
                      />
                      <label htmlFor="file">
                        <span className="material-icons-outlined">
                          upload_file
                        </span>
                      </label>
                    </div>
                    <div className="row">
                      {this.state.previewImage.map((image, index) => (
                        <div className="col" key={index}>
                          <img
                            className="img-thumbnail"
                            width="150"
                            src={image}
                            alt="documents"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <p className="lead">
                    Amount Due
                    <span>0</span>
                  </p>
                  <div className="table-responsive">
                    <table className="table table-condensed">
                      <tbody>
                        <tr>
                          <th>Subtotal:</th>
                          <td>0</td>
                        </tr>
                        <tr>
                          <th>Tax 0%</th>
                          <td>0</td>
                        </tr>
                        <tr>
                          <th>Total:</th>
                          <td>0</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <footer className="card-footer">
                <button
                  className="btn btn-success w-100"
                  type="submit"
                  disabled={this.state.btnDisable}
                >
                  Submit Entries
                </button>
              </footer>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
